import { Page } from '@/components/layout';
import { EVENTS_BY_SLUG } from '@/features/events';
import { BA_META } from './ba.content';
import { BaHero } from './sections/BaHero';
import { BaProgram } from './sections/BaProgram';
import { InvitadasBuenosAires } from './sections/InvitadasBuenosAires';
import { BaAzrahel, BaBenefits, BaChamber, BaTickets, BaVolverALaGira } from './sections/BaBlocks';
import { CancunUpsell, FaqSection, SocialProofSection } from '@/pages/shared/BriefBlocks';
import { CtaBand, PorQueIr, ReservaCta } from '@/pages/shared/ConversionBlocks';

/**
 * BUENOS AIRES (`/buenos-aires`) — recreacion de `DEMO_1_BuenosAires.png`.
 *
 * Secciones en el orden del mockup: hero (marca, ciudad, fechas, titular con
 * acento script y promesa) · 4 beneficios · programa de 2 dias · Camara Cuantica
 * · Azrahel · entradas.
 *
 * TODO dato sale de `src/features/events` (ADR-003): ni una fecha, ni una hora,
 * ni un titulo de bloque escritos a mano en esta pagina.
 *
 * Mapa medido: `docs/sections/BUENOS_AIRES_SECTION_MAP.md`.
 * Desviaciones deliberadas: `docs/VISUAL_DEVIATIONS.md` §2.
 */
export function BuenosAiresPage() {
  // `EVENTS_BY_SLUG` esta tipado como Record<EventSlug, TourEvent>: la clave es
  // literal y el valor no puede ser `undefined`. `getEventBySlug` acepta un
  // string cualquiera y por eso devuelve opcional; aqui no hace falta.
  const event = EVENTS_BY_SLUG['buenos-aires'];

  return (
    <Page documentTitle={BA_META.documentTitle} description={BA_META.description} tone={event.heroTone}>
      <BaHero event={event} />
      {/* --- ENCARGO DEL CLIENTE 28-jul-2026 (Loom, revisado sobre ESTA página) ---
          «debajo de "recupera tu automaestría" [la última línea de la promesa del
          hero] nos gustaría ya meter un CTA de compra, es decir, reserva, que
          tenga mucho detalle» · «justo debajo del CTA también meter el por qué
          ir». Van en ese orden y pegados al hero: es la estructura que aprobaron
          aquí y que replican las otras cuatro ciudades. */}
      <ReservaCta event={event} />
      <InvitadasBuenosAires />
      <BaBenefits event={event} />
      {/* El programa AHORA PUBLICA SUS HORAS (revoca B-16): «el programa meter y
          explicar mejor, que Luis lo ha pasado en el PDF, para que tenga mucho
          detalle». */}
      <BaProgram event={event} />
      {/* «arriba de esto y justo debajo también, meter el comprar la entrada»:
          arriba lo cubre `ReservaCta`, debajo esta banda. Y «justo debajo del
          CTA de aquí, meter el por qué ir» — de ahí este orden exacto, que es el
          del recorrido que hicieron en el vídeo. */}
      <CtaBand event={event} />
      <PorQueIr event={event} background="alt" />
      <BaChamber />
      <BaAzrahel />
      {/* --- Bloques exigidos por el brief, no dibujados por el mockup (ADR-006) --- */}
      <SocialProofSection />
      <BaTickets event={event} />
      {/* `desde` pinta «el recorrido de la gira termina aquí; después de Buenos
          Aires, el último escalón», y el bloque trae ahora su propio botón de
          reserva: las dos cosas que pidieron sobre este mismo bloque. */}
      <CancunUpsell desde={event} />
      <FaqSection items={event.faq} titulo="Preguntas frecuentes · Buenos Aires" grupo="faq-buenos-aires" />
      <BaVolverALaGira />
    </Page>
  );
}
